
const stateManager = require('../../state/stateManager.js');
const validator = require('../../validator/validator.js');
const staffUtility = require('./staffUtility');
const staffActivities = require('./staffActivities');


module.exports.canCurrentStaffPerformActivity = function (activity)
{
    return this.canStaffPerformActivity(staffUtility.getLoginStaff(), activity);
}

module.exports.canStaffPerformActivity = function (staff, activity)
{
    const staffRoles = stateManager.getStore().getState().staffRoles;
    const roles = staff.roles.split(",");
    for (let index = 0; index < roles.length; index++) 
    {
        const roleId = roles[index];
        const staffRole = staffRoles.find(x => x.id === roleId);
        if (staffRole)
        {
            const roleAction = staffRole.actions.find(x => x.actionCode === activity);
            if (roleAction)
                return true;
        }
    }

    return false;
}

module.exports.canStaffIssueFixedDiscount = function (staff, discountValue)
{
    if (this.canStaffPerformActivity(staff, staffActivities.canApplyDiscount))
    {
        return validator.isNumeric(staff.voucherFixedDiscountLimit) && Number(staff.voucherFixedDiscountLimit) > Number(discountValue);
    }

    return false;
}

module.exports.canStaffIssuePercentageDiscount = function (staff, discountValue)
{
    if (this.canStaffPerformActivity(staff, staffActivities.canApplyDiscount))
    {
        return validator.isNumeric(staff.voucherPercentageDiscountLimit) && Number(staff.voucherPercentageDiscountLimit) > Number(discountValue);
    }

    return false;
}
